export function EmailSettings(props) {
    return <div>Email Settings</div>
}